import { ReducerBuilder } from './reducerBuilder';
import { Quote, QuotesState } from 'acscp/store/quotesState';
import { QuoteAcceptRequest, QuotesRequest } from 'acscp/api/requests';
import { QuotesList } from 'acscp/api/models/quotesList';
import { Quote as QuoteApiModel } from 'acscp/api/models/quote';
import { BookingImage } from 'acscp/api/models/bookingImage';
import { QuoteLeg } from 'acscp/store';

export const quotesReducer =
    new ReducerBuilder<QuotesState>({
        quotesList: {},
    })
        .successfulRequestCase(QuotesRequest, (state, quotesList: QuotesList, request) => {

            const storedQuotesForOtherBookings = Object.keys(state.quotesList)
                .map(key => state.quotesList[key])
                .filter(quote => quote.bookingId !== request.bookingId);

            const updatedBookingQuotes = quotesList.quotes
                .map(quote => buildModelQuote(quote, request.bookingId));

            const newState: QuotesState = {quotesList: {}};

            storedQuotesForOtherBookings
                .concat(updatedBookingQuotes)
                .forEach(quote => {
                    newState.quotesList[quote.id] = quote;
                });

            return newState;
        })
        .successfulRequestCase(QuoteAcceptRequest, (state, quote: QuoteApiModel, request) => {
            const oldQuote = state.quotesList[quote.id];
            const quoteBookingId = oldQuote.bookingId;

            return {
                quotesList: {
                    ...state.quotesList,
                    [quote.id]: buildModelQuote(quote, quoteBookingId)
                }
            };
        })
        .build();

function buildModelQuote(apiQuote: QuoteApiModel, bookingId: string): Quote {
    const legs: QuoteLeg[] = apiQuote.legs.map(leg => ({...leg, quoteId: apiQuote.id}));

    return {
        ...apiQuote,
        bookingId,
        legs,
        images: {
            exterior: apiQuote.images.filter(i => i.imageType === 'Exterior')[0],
            interior: apiQuote.images.filter(i => i.imageType === 'Interior')[0],
            floorplan: apiQuote.images.filter(i => i.imageType === 'Floorplan')[0],
            all: apiQuote.images.sort(imageComparer)
        },
    };
}

const imageComparer = (image: BookingImage, other: BookingImage) => getImageOrder(image) - getImageOrder(other);

function getImageOrder(image: BookingImage): number {
    switch (image.imageType) {
        case 'Exterior':
            return 0;
        case 'Interior':
            return 1;
        case 'Floorplan':
            return 2;
    }
}
